import { observer } from "mobx-react";
import * as React from "react";
import { Link } from "react-router";
import styled, { css } from "styled-components";

import Style from "@client/utils/Style";

import linkArrowImage from "./images/link-arrow.svg";

export type FieldType = {
  label: string;
  value: React.ReactNode | typeof undefined;
  link?: string | null;
  showOnNull?: boolean;
  useFullWidth?: boolean;
};

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: -24px;
`;
const Field = styled.div<{ useFullWidth?: boolean; wide: boolean }>`
  width: ${props => (props.useFullWidth ? 100 : 50)}%;
  margin-top: 24px;
  ${props =>
    props.wide
      ? css`
          width: 100%;
        `
      : ""}
`;
const FieldLabel = styled.div`
  font-size: 10px;
  font-weight: ${Style.fontWeights.medium};
  text-transform: uppercase;
  color: ${Style.palette.grayscale[3]};
`;
const FieldValue = styled.div`
  color: ${Style.palette.primary};
  margin-top: 2px;
  word-break: break-word;
`;
const FieldLink = styled(Link)`
  width: 14px;
  height: 14px;
  background: url("${linkArrowImage}") center no-repeat;
  display: inline-block;
  position: relative;
  top: 2px;
  left: 4px;
`;

type Props = {
  fields: FieldType[];
};

@observer
class DetailsPageFields extends React.Component<Props> {
  render() {
    return (
      <Wrapper>
        {this.props.fields.map(field =>
          field.value == null && !field.showOnNull ? null : (
            <Field
              key={field.label}
              wide={field.label.toLowerCase() === "description"}
              useFullWidth={field.useFullWidth}
            >
              <FieldLabel>{field.label}</FieldLabel>
              <FieldValue>
                {field.value || "-"}
                {field.link ? <FieldLink to={field.link} /> : null}
              </FieldValue>
            </Field>
          ),
        )}
      </Wrapper>
    );
  }
}

export default DetailsPageFields;
